import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReelsComponent } from './reels.component';
import { ReelsSliderComponent } from './reels-slider/reels-slider.component';
import { ReelItemComponent } from './reel-item/reel-item.component';
import { TranslateModule } from '@ngx-translate/core';
import { SliderProModule } from '../slider-pro/slider-pro.module';
import { MainTitleModule } from '../main-title/main-title.module';

@NgModule({
  declarations: [
    ReelsComponent,
    ReelsSliderComponent,
    ReelItemComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    SliderProModule,
    MainTitleModule
  ],
  exports: [
    ReelsComponent
  ]
})
export class ReelsModule { }
